import React from 'react'
import Img from 'gatsby-image'
import './styles.scss'

const Image = (props) => {
  const { image, alt = 'LaunchDarkly', className = '' } = props

  if (!image) return <div className={`gatsby-image placeholder ${className}`} />

  if (image && image.childImageSharp && image.childImageSharp.fluid) {
    return (
      <Img
        className={`gatsby-image ${className}`}
        fluid={image.childImageSharp.fluid}
        alt={image.alt || alt || 'LaunchDarkly'}
        loading="eager"
      />
    )
  }

  if (image.localFile && image.localFile.childImageSharp && image.localFile.childImageSharp.fluid) {
    return (
      <Img
        className={`gatsby-image ${className}`}
        fluid={image.localFile.childImageSharp.fluid}
        alt={image.alt || alt || 'LaunchDarkly'}
        loading="eager"
      />
    )
  }

  if (image.url || image.publicURL) {
    return (
      <div className={`gatsby-image no-sharp ${className}`}>
        <img src={image.url || image.publicURL} alt={image.alt || alt} />
      </div>
    )
  }

  return (
    <div className={`gatsby-image ${className}`}>
      <img src={image} alt={alt} />
    </div>
  )
}

export default Image
